// Google Tag Manager Configuration
// ALL tracking goes through dataLayer → GTM. No direct gtag/GA4 script injection.
// Consent: o site não tem banner de cookies (decisão do dono, 10/2026). O único
// `consent default` vive no index.html com todos os sinais = granted.

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const GTM_ID = 'GTM-KGGTZRWN';

// Initialize dataLayer (always, before GTM loads)
export const initDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
};

// Mantido por compatibilidade: sem banner, o consentimento é sempre concedido.
export const checkStoredConsent = (): boolean => true;

// O gtm.js é carregado pelo loader do index.html; aqui só garantimos a chamada.
export const initGTM = () => {
  const loadGTM = (window as any).nathofLoadGTM;
  if (typeof loadGTM === 'function') loadGTM();
};

export const hasConsent = (): boolean => true;
